type TPinterestEvent = {
  eventName: string
  params?: object
}

type TAddToCartParams = {
  value: number
  currency: string
  productId: string
  productName: string
  productPrice: number
}

type TCheckoutParams = {
  value: number
  currency: string
  orderId: string
  productId: string
  productName: string
  productPrice: number
}

class PinterestPixelService {
  private isReady = false
  private eventQueue: TPinterestEvent[] = []

  load(tagId: string): void {
    if (this.isReady) return

    window.pintrk('load', tagId, { em: '' })
    this.isReady = true
    this.flushQueue()
  }

  track(eventName: string, params?: object): void {
    if (this.isReady) {
      this.executeTrack(eventName, params)
    } else {
      this.eventQueue.push({ eventName, params })
    }
  }

  trackPage(): void {
    if (this.isReady) {
      window.pintrk?.('page')
    }
  }

  trackPageVisit(): void {
    this.track('pagevisit')
  }

  trackLead(): void {
    this.track('lead')
  }

  trackAddToCart({
    value,
    currency,
    productId,
    productName,
    productPrice,
  }: TAddToCartParams): void {
    this.track('addtocart', {
      value,
      currency: currency.toUpperCase(),
      line_items: [
        {
          product_category: 'wellness',
          product_name: productName,
          product_id: productId,
          product_price: productPrice,
        },
      ],
    })
  }

  trackCheckout({
    value,
    currency,
    orderId,
    productId,
    productName,
    productPrice,
  }: TCheckoutParams): void {
    this.track('checkout', {
      value,
      currency: currency.toUpperCase(),
      order_id: orderId,
      event_id: orderId,
      external_id: orderId,
      line_items: [
        {
          product_category: 'wellness',
          product_name: productName,
          product_id: productId,
          product_price: productPrice,
        },
      ],
    })
  }

  private flushQueue(): void {
    while (this.eventQueue.length > 0) {
      const event = this.eventQueue.shift()
      if (event) {
        this.executeTrack(event.eventName, event.params)
      }
    }
  }

  private executeTrack(eventName: string, params?: object): void {
    if (params) {
      window.pintrk?.('track', eventName, params)
    } else {
      window.pintrk?.('track', eventName)
    }
  }
}

export const pinterestPixelService = new PinterestPixelService()
